import React from 'react';
import _ from 'lodash';
import Dialog from '@material-ui/core/Dialog';
import Button from 'components/Button';
import { Container, Header, Body } from 'styles/pages/home/loginDialog';

const AccountInformationDialog = ({ open, onClose, inProcess }) => (
  <Dialog
    maxWidth='md'
    open={open}
    onClose={() => _.isFunction(onClose) && onClose()}>
    <Container>
      <Header>
        <img src='https://bigoventees.com/img/back2.png' alt='logo' />
      </Header>
      <Body>
        {inProcess ? (
          <>
            <h2>
              Your account information will be reviewed within two to three
              business days by our team.
            </h2>
            <h2>You will be notified via email if your account is approved.</h2>
          </>
        ) : (
          <h2>Sorry, we have to Decline your request.</h2>
        )}
        <Button
          variant='contained'
          title='Ok'
          onClick={() => _.isFunction(onClose) && onClose()}
        />
      </Body>
    </Container>
  </Dialog>
);

export default AccountInformationDialog;
